import React, { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { Link } from "react-router-dom";

import PassWordImg from "../../assets/authPages/forgotPassRightImg.png";
// import {ReactComponent as BilbioLogo} from "../../assets/authPages/authLogo.svg";
import { ReactComponent as BilbioLogo } from "../../assets/NewLogo.svg";
import { ReactComponent as BilBioLogoDark } from "../../assets/NewLogoDark.svg";
import OgImage from "../../assets/landingPages/homePage/Hero.png";
import { ReactComponent as GlobeIcon } from "../../assets/landingPages/header/globe.svg";
import { ReactComponent as GlobeIconDark } from "../../assets/landingPages/header/globeDark.svg";
import useLocales from "../../hooks/useLocales";
import useSettings from "../../hooks/useSettings";

import axios from "axios";
import { toast } from "react-hot-toast";
import { Helmet } from "react-helmet";
import { useSelector } from "react-redux";

const baseUrl = process.env.REACT_APP_API_URL;

const ForgotPassword = () => {
  const { darkMode } = useSelector((state) => state.theme);
  const [pending, setPending] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = async (data) => {
    const emailData = {
      email: data.email,
    };
    resetUserPassword(emailData);
  };

  const { translate, onChangeLang, allLangs } = useLocales();
  const { themeDirection } = useSettings();
  const [isOpenLangModal, setIsOpenLangModal] = useState(false); // Variable to manage the language modal open/close state
  const [isOpenLangMModal, setIsOpenLangMModal] = useState(false); // Variable to manage the mobile language modal open/close state
  const iconRef = useRef(); // Reference for icon element
  const modalRef = useRef(); // Reference for modal element
  // Adding an event listener to handle clicks outside the language modal (for desktop)
  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (
        isOpenLangModal &&
        modalRef.current &&
        !modalRef.current.contains(e.target) &&
        !iconRef.current.contains(e.target)
      ) {
        setIsOpenLangModal(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [isOpenLangModal]);

  const resetUserPassword = async (userDatas) => {
    setPending(true);
    try {
      const path = "/api/user/send-reset-password-email";
      const url = baseUrl + path;

      const response = await axios.post(url, userDatas);
      setPending(false);

      if (response?.data?.status === "success") {
        toast.success(response?.data?.message);
      } else {
        toast.error(response?.data?.message);
      }
      return response?.data;
    } catch (error) {
      setPending(false);
      toast.error(error?.message);
      console.error(error.message);
    }
  };
  // Function to change the language and close the language modal
  const handleChangeLang = (newLang) => {
    onChangeLang(newLang); // Change the language
    setIsOpenLangModal(false); // Close the language modal
    setIsOpenLangMModal(false); // Close the mobile language modal
  };
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Forgot Password | Bil.Bio</title>
        <meta property="og:title" content="Forgot Password | Bil.Bio" />
        <meta property="og:url" content={window.location.href} />
        <meta property="og:image" content={window.location.origin + OgImage} />
        <meta property="og:description" content="Create Bio Link page" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content="Bil.Bio" />
        <meta
          name="twitter:description"
          content="Bil.Bio | All links in link"
        />
        <meta name="twitter:site" content="@BilBioHQ" />
        <meta name="twitter:image" content={window.location.origin + OgImage} />
      </Helmet>
      <div
        className={`flex flex-col lg:flex-row relative ${
          themeDirection === "rtl" ? "lg:flex-row-reverse" : ""
        }`}
      >
        <div className="block sm:mt-0 sm:items-center p-6 sm:p-10  w-full min-h-screen h-screen overflow-y-auto xsmfold:px-2 xsml:px-5 smm:px-12 md:px-32 lg:px-16 xl:px-28 2xl:px-44">
          <div className="xl:mx-[-55px] bg-white dark:bg-dark-primary flex items-center justify-between flex-wrap">
            <Link to={"/"} className="flex items-center w-[80px] lg:w-[121px]">
              {darkMode ? (
                <BilBioLogoDark className="w-[100%] sm:w-[100%] h-auto" />
              ) : (
                <BilbioLogo className="w-[100%] sm:w-[100%] h-auto" />
              )}
            </Link>
            <div className="relative ml-12">
              {isOpenLangModal && (
                <div
                  ref={modalRef}
                  className="absolute rounded-xl bg-[#fbf7f7]  dark:bg-dark-secondary top-11 -right-2.5"
                >
                  <div className="flex relative rounded-xl w-max flex-col p-2 gap-2">
                    <div className="absolute h-3 w-3 bg-[#fbf7f7] dark:bg-dark-secondary -top-1.5 right-4 rotate-45"></div>
                    {allLangs.map((lang) => (
                      <div
                        key={lang?.value}
                        onClick={() => handleChangeLang(lang?.value)}
                        className={`p-1 px-2 hover:bg-gray-100 dark:hover:bg-dark-primary cursor-pointer rounded-lg ${
                          themeDirection === "rtl" ? "flex-row-reverse" : ""
                        } flex items-center gap-2 min-w-fit`}
                      >
                        <p className="whitespace-nowrap dark:text-color_v1_dark">
                          {lang?.label}
                        </p>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {darkMode ? (
                <GlobeIconDark
                  onClick={() => setIsOpenLangModal(!isOpenLangModal)}
                  className="cursor-pointer ml-2" // Adjust the margin-left as needed
                  ref={iconRef}
                />
              ) : (
                <GlobeIcon
                  onClick={() => setIsOpenLangModal(!isOpenLangModal)}
                  className="cursor-pointer ml-2" // Adjust the margin-left as needed
                  ref={iconRef}
                />
              )}
            </div>
          </div>

          <div className="w-full">
            <div className="flex items-center justify-center mt-[70px]">
              <div className="mt-5">
                <h1 className="mb-2 text-custom_h5 sm:text-custom_h4 text-center text-heading_color dark:text-color_v1_dark">
                  {translate("auth.forgot_your_password")}
                </h1>
                <h6 className="text-center text-small2 sm:text-small1 text-font_light_color dark:text-color_v2_dark xsmfold:mb-6 xsml:mb-10 lg:mb-8 xl:mb-16">
                  {translate("forgot_desc")}
                  <br /> {translate("forgot_description")}
                </h6>
              </div>
            </div>
            <form
              onSubmit={handleSubmit((data) => onSubmit(data))}
              className=" flex justify-center"
            >
              <div className="max-w-[482px] w-full">
                <div className="flex flex-col gap-4 mb-6">
                  <div>
                    <label
                      htmlFor="email"
                      className="block ml-[15px] mb-1 text-small2 sm:text-body_copy2 text-heading_color dark:text-color_v1_dark"
                    >
                      {translate("email")}
                    </label>

                    <input
                      type="email"
                      id="email"
                      {...register("email", {
                        required: "Email Required",
                      })}
                      className={`text-small2 sm:text-body_copy2 border rounded-md focus:outline-none block w-full py-[5px] sm:py-[7px] p-[13px] sm:p-[15px] dark:bg-dark-primary  dark:text-color_v1_dark placeholder:dark:text-font_light_color dark:caret-white focus:placeholder:dark:text-color_v1_dark ${
                        errors?.email
                          ? "border-state_color_error placeholder:text-state_color_error"
                          : "border-light_bg_v2 bg-transparent focus:border-font_light_color placeholder:text-font_light_color focus:placeholder:text-heading_color dark:border-color_dark focus:dark:border-font_color"
                      }`}
                      placeholder={translate("auth.enter_page_email")}
                    />

                    {errors?.email && (
                      <small className="text-state_color_error text-small3">
                        {errors?.email?.message}
                      </small>
                    )}
                  </div>
                </div>

                <button
                  type="submit"
                  className={`mt-2 xsmm:mt-4 xsml:mt-5 sm:mt-7 bg-[#FF5349] text-white rounded-full w-full p-2 pt-[13px] pb-[12px] text-small1_bold ${
                    pending ? "opacity-60" : ""
                  }`}
                >
                  {pending ? (
                    <svg
                      aria-hidden="true"
                      role="status"
                      className="inline w-4 h-4 mr-3 text-white animate-spin"
                      viewBox="0 0 100 101"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                        fill="#E5E7EB"
                      />
                      <path
                        d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                        fill="currentColor"
                      />
                    </svg>
                  ) : (
                    `${translate("submit")}`
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
        <div className="hidden lg:block md:h-auto md:w-full  h-screen">
          <img
            className="object-cover w-full h-screen"
            src={PassWordImg}
            alt="img"
            title={"image"}
          />
        </div>
      </div>
    </>
  );
};

export default ForgotPassword;
